import e from "./SearchBox.vue_rollup-plugin-vue=script.js";
export default (function (e, t, n, i, r, o, s, u) {
  var c = ("function" == typeof n ? n.options : n) || {};
  return c.__file = "SearchBox.vue", c.render || (c.render = e.render, c.staticRenderFns = e.staticRenderFns, c._compiled = !0, r && (c.functional = !0)), c._scopeId = i, c;
})({
  render: function render() {
    var e = this,
        t = e.$createElement,
        n = e._self._c || t;
    return e.state ? n("div", {
      class: e.suit()
    }, [e._t("default", function () {
      return [n("search-input", {
        ref: "searchInput",
        attrs: {
          placeholder: e.placeholder,
          autofocus: e.autofocus,
          "show-loading-indicator": e.showLoadingIndicator,
          "should-show-loading-indicator": e.state.isSearchStalled,
          "ignore-composition-events": e.ignoreCompositionEvents,
          "submit-title": e.submitTitle,
          "reset-title": e.resetTitle,
          "class-names": e.classNames
        },
        on: {
          focus: function focus(t) {
            return e.$emit("focus", t);
          },
          blur: function blur(t) {
            return e.$emit("blur", t);
          },
          reset: function reset(t) {
            return e.$emit("reset");
          }
        },
        scopedSlots: e._u([e.isVue3 ? {
          key: "loading-indicator",
          fn: function fn() {
            return [e._t("loading-indicator")];
          },
          proxy: !0
        } : null, e.isVue3 ? {
          key: "submit-icon",
          fn: function fn() {
            return [e._t("submit-icon")];
          },
          proxy: !0
        } : null, e.isVue3 ? {
          key: "reset-icon",
          fn: function fn() {
            return [e._t("reset-icon")];
          },
          proxy: !0
        } : null], null, !0),
        model: {
          value: e.currentRefinement,
          callback: function callback(t) {
            e.currentRefinement = t;
          },
          expression: "currentRefinement"
        }
      }, [e._v(" "), e.isVue2 ? e._t("loading-indicator", null, {
        slot: "loading-indicator"
      }) : e._e(), e._v(" "), e._v(" "), e.isVue2 ? e._t("submit-icon", null, {
        slot: "submit-icon"
      }) : e._e(), e._v(" "), e._v(" "), e.isVue2 ? e._t("reset-icon", null, {
        slot: "reset-icon"
      }) : e._e()], 2)];
    }, {
      currentRefinement: e.currentRefinement,
      isSearchStalled: e.state.isSearchStalled,
      refine: e.state.refine
    })], 2) : e._e();
  },
  staticRenderFns: []
}, 0, e, void 0, !1);